/* Monilee and Bella — show only the selected colour's photos.
   A product image is treated as colour-specific when its alt text names one or two
   of the product's colours (the first one named wins). Images naming no colour, or
   three or more colours (e.g. "available in black, navy, sand…"), always stay visible. */
(function () {
  var NAMES = ['colour', 'color'];

  function colourInfo() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return null;
    var sets = vs.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (lg && NAMES.indexOf(lg.textContent.trim().toLowerCase()) >= 0) {
        var vals = [], sel = null;
        sets[i].querySelectorAll('input[type="radio"]').forEach(function (x) {
          vals.push(x.value);
          if (x.checked) sel = x.value;
        });
        return { values: vals, selected: sel };
      }
    }
    var drops = vs.querySelectorAll('.product-form__input--dropdown');
    for (var j = 0; j < drops.length; j++) {
      var lb = drops[j].querySelector('label');
      var s = drops[j].querySelector('select');
      if (lb && s && NAMES.indexOf(lb.textContent.trim().toLowerCase()) >= 0) {
        var v2 = [];
        Array.prototype.forEach.call(s.options, function (o) { v2.push(o.value); });
        return { values: v2, selected: s.value };
      }
    }
    return null;
  }

  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function imageColour(alt, values) {
    alt = (alt || '').toLowerCase();
    var hits = [];
    values.forEach(function (v) {
      var m = new RegExp('\\b' + esc(v.toLowerCase()) + '\\b').exec(alt);
      if (m) hits.push({ v: v, i: m.index });
    });
    if (hits.length === 0 || hits.length >= 3) return null;
    hits.sort(function (a, b) { return a.i - b.i; });
    return hits[0].v;
  }

  function apply() {
    var c = colourInfo();
    if (!c || !c.selected || c.values.length < 2) return;
    document
      .querySelectorAll('media-gallery li.product__media-item, media-gallery li.thumbnail-list__item')
      .forEach(function (li) {
        var img = li.querySelector('img');
        if (!img) return;
        var col = imageColour(img.getAttribute('alt'), c.values);
        li.style.display = col && col !== c.selected ? 'none' : '';
        li.dataset.mbColourMatch = col && col === c.selected ? '1' : '';
      });
    // Keep the selected colour's photos together, right after the first image.
    document.querySelectorAll('media-gallery ul.product__media-list').forEach(function (ul) {
      var items = Array.prototype.filter.call(ul.children, function (li) {
        return li.matches('li.product__media-item') && li.style.display !== 'none';
      });
      if (items.length < 2) return;
      var anchor = items[0];
      items.slice(1).forEach(function (li) {
        if (li.dataset.mbColourMatch === '1') {
          ul.insertBefore(li, anchor.nextSibling);
          anchor = li;
        }
      });
    });
  }

  function later() { setTimeout(apply, 0); setTimeout(apply, 350); setTimeout(apply, 1000); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later);
  else later();
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) later();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, later);
  }
})();
